import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { exchangeCodeForTokens } from '../lib/auth';
import { consumeReturnTo } from '../lib/returnTo';
import { theme } from '../theme';

export function OAuthCallback() {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    if (!code) {
      setError('No authorization code in callback URL');
      return;
    }
    exchangeCodeForTokens(code)
      .then(() => {
        const returnTo = consumeReturnTo() ?? '/scans';
        navigate(returnTo, { replace: true });
      })
      .catch((err: Error) => setError(err.message));
  }, [navigate]);

  return (
    <div style={{ padding: 32, color: theme.text.secondary }}>
      {error ? (
        <>
          <h2>Sign-in failed</h2>
          <pre style={{ color: theme.status.error }}>{error}</pre>
          <a href="/login">Try again</a>
        </>
      ) : (
        <p>Completing sign-in…</p>
      )}
    </div>
  );
}
